<template>
    <div class="mt-4">
        <div class="card bg-gray-100 mb-5" v-if="showHeader">
            <div class="d-lg-flex justify-content-between align-items-center p-3">
                <h4>{{ trans('general.observations.observe_child_dev') }}</h4>
                <div class="d-flex gap-2 ">
                    <guide-drop
                        v-if="loaded"
                        :items="statusData.grade"
                        @click="addNote"
                        @openMilestonesPanel="openMilestonesPanel"/>

                    <basic-button
                        :text="trans('general.observations.generate_reports')"
                        class="btn-primary"
                        icon="fi-rr-chart-histogram"
                        @click="openGenerateReportPanel"/>
                </div>
            </div>
        </div>
        <observation-form
            v-if="loaded && child.group_id"
            ref="developmentForm"
            :child-id="child.id"
            :class-id="child.group_id"
            :status-data="statusData"
            :roles="roles"
            @addNote="addNote"
            @observationAdded="handleUpdate" />

        <development-topic-note-modal ref="developmentTopicNoteModal" @success="reload"/>
    </div>
</template>

<script>
import ObservationForm from "../../molecules/ObservationForm.vue";
import ObservationTopicNoteModal from "../ObservationTopicNoteModal.vue";
import BasicButton from "../../../../theme/atoms/BasicButton.vue";
import DevelopmentSuggestions from "../../molecules/DevelopmentSuggestions.vue";
import OverallDevelopmentScore from "../../molecules/OverallDevelopmentScore.vue";
import DropDownButton from "../../../../theme/atoms/DropDownButton.vue";
import GuideDrop from "../../molecules/GuideDrop.vue";

export default {
    name: "ChildObservations",
    components: {
        GuideDrop,
        DropDownButton,
        DevelopmentSuggestions, OverallDevelopmentScore,
        DevelopmentTopicNoteModal: ObservationTopicNoteModal, ObservationForm, BasicButton
    },
    props: {
        child: {
            type: Object,
            required: true
        },
        showHeader: {
            type: Boolean,
            default: true
        },
        roles: {
            type: Array,
            required: true
        }
    },
    computed: {
        developmentReportId() {
            return this.statusData?.topics[0]?.development_report_id;
        }
    },
    data() {
        return {
            loaded: false,
            statusData: null,
        }
    },
    methods: {
        addNote(data) {
            this.$refs.developmentTopicNoteModal.open(data);
        },
        reload() {
            this.$refs.developmentForm.reload();
        },
        openGenerateReportPanel() {
            const panel = this.$showPanel({
                component: 'generate-development-report-form-panel',
                openOn: 'right',
                cssClass: 'sidePanel',
                width: 1024,
                props: {
                    child: this.child
                }
            })

            panel.promise.then(result => {
                result.hide();
            })
        },

        openMilestonesPanel() {
            this.$showPanel({
                component: 'milestones-badges-panel',
                openOn: 'right',
                cssClass: 'sidePanel',
                width: 1024,
                props: {
                    developmentReportId: this.statusData?.topics[0]?.development_report_id
                }
            })
        },

        async loadStatusDevelopmentReportData() {
            this.loaded = false;
            const {data} = await axios.get(`/development-reports/${this.child.id}/data-status`)
            this.statusData = data.data;

            this.loaded = true;
        },

        handleUpdate() {
            //this.loadStatusDevelopmentReportData().then(() => {});
        },
    },
    async mounted() {
        await this.loadStatusDevelopmentReportData()
    }
}
</script>
<style scoped>
.min-width-mobile {
    min-width: 320px;
}
</style>
